/* eslint-disable */
/* eslint-disable react/prop-types */
import React from 'react'
import { scaleRadial, scaleBand } from 'd3-scale'
import { max } from 'd3-array'
import { arc, stack } from 'd3-shape'
import find from 'lodash/find'
import Color from '../../../Utilities/Colors/ColorMap'
import Legend from '../../../Legend/Legend'
import PitchTypeToPitchName from '../../../Utilities/Mapping/PitchTypeToPitchName'

export default function Axis({ settings, chartOptions = {} }) {
    const innerRadius = chartOptions.innerRadius || 67
    const outerRadius = chartOptions.outerRadius || 200

    const pitchTypes = chartOptions.pitchTypes || [
        'infer_n_ff',
        'infer_n_si',
        'infer_n_fc',
        'infer_n_ch',
        'infer_n_sl',
        'infer_n_cu',
        'infer_n_fs',
        'infer_n_st',
        'infer_n_sv',
        'infer_n_sc',
        'infer_n_fo',
        'infer_n_kc',
    ]

    const spinData = settings.data

    const pitchTypeOrder = pitchTypes.map((d) => d.split('_')[2].toUpperCase())

    const usedPitchTypes = spinData
        .map((row) =>
            pitchTypes
                .map((type) => ({
                    type,
                    n: Number(row[type]),
                }))
                .filter((d) => d.n > 0)
                // This may not work someday...
                .map((d) => d.type.split('_')[2].toUpperCase())
        )
        .flat()

    const uniquePitchTypes = Array.from(new Set(usedPitchTypes))
        .map((d) => ({
            pitchType: d,
            pitchName: PitchTypeToPitchName(d),
        }))
        .sort((a, b) => {
            const aIndex = pitchTypeOrder.indexOf(a.pitchType)
            const bIndex = pitchTypeOrder.indexOf(b.pitchType)
            return aIndex - bIndex
        })

    const y = scaleRadial()
        .domain([0, max(spinData, (d) => Number(d.y))])
        .range([innerRadius, outerRadius])

    const x = scaleBand()
        .domain(spinData.map((d) => d.x))
        .range([0, 2 * Math.PI])
        .align(0)

    const arcShape = arc()
        .innerRadius((d) => y(d[0]))
        .outerRadius((d) => y(d[1]))
        .startAngle((d) => x(d.data.x))
        .endAngle((d) => x(d.data.x) + x.bandwidth())
        .padAngle(0.01)
        .padRadius(innerRadius)

    const stacks = stack().keys(pitchTypes)(spinData)

    return (
        <>
            <g
                transform={`translate(${settings.vizWidth / 2},${
                    settings.vizWidth / 2
                })`}
                key="spinAxisChart"
                id="spinAxisChart"
            >
                {stacks.map((layer, i) => {
                    const pitchType = String(
                        layer.key.split('_')[2]
                    ).toUpperCase()
                    const pitchColor = Color('pitchName', pitchType)
                    return (
                        <g
                            key={`radial_${i}`}
                            fill={pitchColor}
                            opacity={chartOptions.opacity}
                        >
                            {layer.map((pitch, i) => (
                                <path
                                    key={`axis_path_${i}`}
                                    d={arcShape(pitch)}
                                    strokeWidth={
                                        chartOptions.strokeWidth || 0.75
                                    }
                                    stroke={chartOptions.stroke || '#000'}
                                />
                            ))}
                        </g>
                    )
                })}
                {spinData.map((d, i) => (
                    <g
                        key={`axis_sping_${i}`}
                        transform={`rotate(${
                            ((x(d.x) + x.bandwidth() / 2) * 180) / Math.PI - 100
                        })
            translate(${innerRadius},0)`}
                    >
                        <text
                            textAnchor="middle"
                            transform={`${
                                (x(d.x) / 2 + Math.PI / 2) % (2 * Math.PI) <
                                Math.PI
                                    ? 'rotate(90)translate(0,16)'
                                    : 'rotate(-90)translate(0,-9)'
                            }`}
                        >
                            {/* Only show whole number clock face values */}
                            {d.x.indexOf('.5') > -1 ? `` : Number(d.x)}
                        </text>
                    </g>
                ))}
            </g>
            {chartOptions.legend ? (
                <Legend
                    settings={{
                        data: uniquePitchTypes,
                        vizWidth: settings.vizWidth,
                        vizScale: 1,
                    }}
                    type={chartOptions.legendType}
                />
            ) : null}
        </>
    )
}
